var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-map-loader animation-gradient"},[_c('v-icon',{attrs:{"color":_vm.colors.hwayzGray,"size":"120"}},[_vm._v("\n    map\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }